import buildMediaElementFromFieldsValues from './build-media-element-from-fields-values';

const replaceFirstChildWith = (element, newFirstChild) => {
  const firstChild = element.firstElementChild;

  if (!firstChild) return;

  firstChild.replaceWith(newFirstChild);
};

const mediaContainerBuilder = {
  replaceContentWith(mediaContainerElement, newContentElement) {
    replaceFirstChildWith(mediaContainerElement, newContentElement);
  },

  wrapContentWith(mediaContainerElement, newContentElement) {
    const firstChild = mediaContainerElement.firstElementChild;

    if (!firstChild) return;

    const firstChildCopy = firstChild.cloneNode(true);

    newContentElement.appendChild(firstChildCopy);
    replaceFirstChildWith(mediaContainerElement, newContentElement);
  },

  unwrapContent(mediaContainerElement) {
    const secondChild = mediaContainerElement.firstElementChild?.firstElementChild;

    if (!secondChild) return;

    const secondChildCopy = secondChild.cloneNode(true);
    replaceFirstChildWith(mediaContainerElement, secondChildCopy);
  },

  replaceContentFromFieldsValues(mediaContainerElement, mediaType, fieldsValues = {}) {
    if (!mediaType) {
      throw new Error('`mediaType` is required for `replaceContentFromFieldsValues` method');
    }

    const builtElement = buildMediaElementFromFieldsValues(
      mediaType,
      fieldsValues,
      mediaContainerElement
    );

    if (!builtElement) {
      throw new Error(`Failed to build element for media type: ${mediaType}`);
    }

    replaceFirstChildWith(mediaContainerElement, builtElement);

    return builtElement;
  },
};

export default Object.freeze(mediaContainerBuilder);
